import {FrameTypesEnum} from '../../../libs/shared/core/src/models/api/apiTypes';
import {PaletteColorsEnum} from '../../../libs/shared/core/src/models/api/paletteModel';
import {
  ApplicationEntryPointActionFeaturesEnum,
  ApplicationEntryPointActionSdkVersionsEnum,
  ApplicationEntryPointActionTypesEnum,
} from '../../models/api/applicationEntryPointActionModel';
import {
  ApplicationEntryPointTypesEnum,
  SerializedApplicationEntryPointModel,
} from '../../models/api/applicationEntryPointModel';
import {SerializedApplicationModel} from '../../models/api/applicationModel';
import {IntegrationModel} from '../../models/api/integrationModel';

/* The conversion functions in this file are so that integrations
 * with plugins can be rendered as application entry points using
 * the legacy SDK.
 */

export function serializeIntegrationWithPluginToApplicationModel(
  integration: IntegrationModel,
): SerializedApplicationModel | undefined {
  const {plugin} = integration;
  if (!plugin) {
    return undefined;
  }
  const entryPoint = serializeIntegrationWithPluginToEntryPoint(integration);
  if (!entryPoint) {
    return undefined;
  }
  const entryPoints: ReadonlyArray<SerializedApplicationEntryPointModel> = [entryPoint];

  return {
    description: '',
    entryPoints,
    iconUrl: integration.iconsUrl,
    id: integration.id,
    installationKey: plugin.authSecret,
    name: integration.name,
    uid: integration.type,
    updatedAt: integration.updatedAt,
    url: '',
  };
}

function serializeIntegrationWithPluginToEntryPoint(
  integration: IntegrationModel,
): SerializedApplicationEntryPointModel | undefined {
  const {plugin} = integration;
  if (!plugin) {
    return undefined;
  }
  return {
    action: {
      type: ApplicationEntryPointActionTypesEnum.OPEN_SIDE_PANEL,
      endpoint: plugin.endpoint,
      label: undefined,
      sdkVersion: ApplicationEntryPointActionSdkVersionsEnum.LEGACY,
      features: [
        ApplicationEntryPointActionFeaturesEnum.DEVICE_CAMERA,
        ApplicationEntryPointActionFeaturesEnum.DEVICE_MICROPHONE,
      ],
      origin: undefined,
    },
    applicationId: integration.id,
    applicationUid: integration.type,
    // This is a random color so that the type is correct.
    color: PaletteColorsEnum.PINK,
    frameId: integration.frameId,
    frameType: FrameTypesEnum.APPLICATION_ENTRY_POINT,
    name: plugin.name,
    type: ApplicationEntryPointTypesEnum.INBOX_SIDE_PANEL,
    runsInBackgroundMode: false,
  };
}
